import { NgIf, SlicePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { LabeledValue } from 'src/app/models/LabeledValue';
import { User } from 'src/app/models/Security.User';
import { UtilsService } from 'src/app/utils/utils.service';
import { LoginService } from '../login/login.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        NgIf,
        MenubarModule,
        PrimeTemplate,
        RouterLinkActive,
        TagModule,
        PopoverModule,
        Button,
        SelectModule,
        FormsModule,
        SlicePipe,
        TranslateModule
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {

    @Input() isErrorPage = false;

    languages = [];
    selectedLanguage = sessionStorage['currentLangCode'] || 'es';

    currentUser: User;
    items: MenuItem[];
    isOfflineMode = false;
    defaultHome = '/login';
    isLoginOut = false;
    subscriberName = "";
    isExperianAdmin = false;

    protected homes: LabeledValue[] = [
        { label: 'HOME.INNOVATION', value: '/innovation' },
        { label: 'HOME.CARDS', value: '/cards' },
        { label: 'HOME.STANDARD', value: '/standard' },
        { label: 'HOME.FREELANCERS', value: '/freelancers' }
    ];

    private readonly destroy$ = new Subject<void>();

    constructor(
		private readonly router: Router,
		private readonly authenticationService: AuthenticationService,
		private readonly translate: TranslateService,
		public readonly configurationService: ConfigurationService,
        private readonly loginService: LoginService,
        private readonly utilsService: UtilsService
    ) {
        this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => this.currentUser = x);

        setTimeout(() => {
            const currentUser = sessionStorage.getItem('currentUser');
            this.currentUser = JSON.parse(currentUser!); // ! esto quita el null
        }, 1000);
    }

    async ngOnInit() {
        if (!this.configurationService.getConfiguration() && await this.utilsService.getCookieUser()) {
            await this.configurationService.setInitialConfgiguration();
        }

        await Promise.all([this.getLanguages(), this.setDefaultHome(), this.setLangIfStandardAndCa(), this.utilsService.getSubscriberName().then(name => this.subscriberName = name)]);

        // this.setItems();
        // this.isOfflineMode = environment.offlineMode;
    }

    ngOnDestroy(): void {
	    this.destroy$.next();
	    this.destroy$.complete();
    }

    setItems() {
        this.items = [
            {
                label: 'HEADER.MY_REQUESTS',
                escape: false,
                routerLink: this.defaultHome,
                icon: 'account_tree'
            }];

        // if (this.configurationService.getConfiguration().clientEnviroment == 3) {
        //     this.items.push({
        //         label: 'HEADER.ADMINISTRATION',
        //         escape: false,
        //         routerLink: '/freelancers/administration',
        //         icon: 'settings'
        //     });
        // }
    }

    async logout() {
        this.isLoginOut = true;
        await this.loginService.logout();
        this.isLoginOut = false;
    }

    setLanguage(): void {
        sessionStorage['currentLangCode'] = this.selectedLanguage;
        this.translate.use(this.selectedLanguage);
    }

    async setLangIfStandardAndCa(): Promise<void> {
        if (await this.utilsService.getHomeId() === 3 && this.selectedLanguage === 'ca') {
            this.selectedLanguage = 'es';
            this.setLanguage();
        }
    }

    getLanguages(): void {
        this.languages = [...this.translate.getLangs()];
    }

    checkRouteIsActive(item: string): boolean {
        return this.router.url.includes(item);
    }

    async setDefaultHome(): Promise<void> {
        this.isExperianAdmin = await this.utilsService.isExperianAdmin();
        this.defaultHome = this.isExperianAdmin ? `/${this.router.url.split('/')[1]}` : await this.utilsService.getCurrentUserHomePath();
    }
}
